<template>
  <div class="sub-menu">
    <div class="sub-menu__header"  @click="redirect" :class="{clickable: canRedirect }">
      <div class="sub-menu__header__icon" :class="{'sub-menu__header__icon--active': isOnPage}"
           v-if="!done">
        {{cIndex}}
      </div>
      <div v-else class="sub-menu__header__icon"
           :class="{'sub-menu__header__icon--done': done}">
        <font-awesome-icon :icon="['fal', 'check']"></font-awesome-icon>
      </div>
      <div class="sub-menu__header__title bold"
           :class="{'sub-menu__header__title--active': isOnPage}">
        {{title}}
      </div>
    </div>
    <el-collapse-transition v-if="isOnPage">
        <sub-menu-steps
          class="sub-menu__steps"
          :style="{height: `${steps.length * 35}px`}"
          :steps="steps"
        />
    </el-collapse-transition>
  </div>
</template>

<script>
import SubMenuSteps from './SubMenuSteps.vue';

export default {
  name: 'SubMenu',
  components: { SubMenuSteps },
  data() {
    return {
      currentStep: 0,
    };
  },
  props: {
    index: {
      type: Number,
      required: true,
    },
    title: {
      type: String,
      default: 'Step Name',
    },
    steps: {
      type: Array,
      default() {
        return [];
      },
    },
    done: {
      type: Boolean,
      default: false,
    },
    route: {
      type: String,
      default: '',
    },
  },
  computed: {
    cIndex() {
      return this.index + 1;
    },
    isOnPage() {
      const routeName = this.$route.name;

      for (let i = 0; i < this.steps.length; i += 1) {
        if (routeName === this.steps[i]) {
          return true;
        }
      }

      return this.route === routeName;
    },
    canRedirect() {
      return !this.$route.meta.disableNavBar && this.route.length > 0 && this.done;
    },
  },
  methods: {
    redirect() {
      if (this.canRedirect) this.$router.push({ name: `${this.route}Home` });
    },
  },
};
</script>

<style scoped lang="scss">
  .sub-menu{
    &__header{
      display: grid;
      grid-template-columns: 20% 80%;
      column-gap: 15px;
      align-items: center;
      padding: 10px 0 10px 0;

      &__icon{
        display: grid;
        border-radius: $--border-radius-circle;
        width: 28px;
        height: 28px;
        place-items: center;
        place-self: end;
        align-items: center;
        justify-content: center;
        color: white;
        font-family: 'futura-pt-bold', sans-serif;
        font-size: $--font-size-medium;
        background: $--next-dark-blue-light-opacity-40;
        &--active{
          background: $--color-primary;
        }
        &--done{
          color:  $--next-dark-blue-light-opacity-40;
          background: none;
          border: 2px solid  $--next-dark-blue-light-opacity-40;
        }
      }
      &__title {
        color: $--next-dark-blue-light-opacity-40;
        font-size: $--font-size-large;
        text-align: start;
        margin-left: 8px;
        &--active{
          color: $--color-text-primary;
        }
      }
    }
    &__steps {
      margin: 16px 0 22px 0;
      padding-left: 40px;
    }
  }
</style>
